import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home1 from '../pages/Home1';
import Home2 from '../pages/Home2';
import Home3 from '../pages/Home3';
import Home4 from '../pages/Home4';
import Growth from '../pages/Growth';
import Market from '../pages/Market';
import Brand from '../pages/Brand';
import Digital from '../pages/Digital';
import Creative from '../pages/Creative';
import Features from '../pages/Features';
import Pricing from '../pages/Pricing';
import Blog from '../pages/Blog';
import Contact from '../pages/Contact';

const RoutesPaths = () => {
    return (
        <>
            <Routes>
                <Route path='/' element={<Home1 />} />
                <Route path='/home1' element={<Home1 />} />
                <Route path='/home2' element={<Home2 />} />
                <Route path='/home3' element={<Home3 />} />
                <Route path='/home4' element={<Home4 />} />
                <Route path='/growth' element={<Growth />} />
                <Route path='/market' element={<Market />} />
                <Route path='/brand' element={<Brand />} />
                <Route path='/digital' element={<Digital />} />
                <Route path='/creative' element={<Creative />} />
                <Route path='/features' element={<Features />} />
                <Route path='/pricing' element={<Pricing />} />
                <Route path='/blog' element={<Blog />} />
                <Route path='/contact-us' element={<Contact />} />
            </Routes>
        </>

    )
}

export default RoutesPaths;
